import React, { createContext, useContext, useState, useEffect } from 'react';

interface ConfigContextType {
  internalSiteEnabled: boolean;
  setInternalSiteEnabled: (value: boolean) => void;
}

const ConfigContext = createContext<ConfigContextType | undefined>(undefined);

export function ConfigProvider({ children }: { children: React.ReactNode }) {
  const [internalSiteEnabled, setInternalSiteEnabled] = useState(false);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch('Admin/Home/GetIsInternalSite');
        const data = await response.json();
        setInternalSiteEnabled(data.isInternalSite);
      } catch (error) {
        console.error('Error fetching internal site status:', error);
      }
    };

    fetchConfig();
  }, []);

  return (
    <ConfigContext.Provider value={{ internalSiteEnabled, setInternalSiteEnabled }}>
      {children}
    </ConfigContext.Provider>
  );
}

// Custom hook to use the config
export function useConfig() {
  const context = useContext(ConfigContext);
  if (context === undefined) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
} 